import { notifyError, notifySuccess } from "@lib/helper"
import http from "../httpService"
import { L, LNotification } from "@lib/abpUtility"
import { PagedResultDto } from "@services/dto/pagedResultDto"

class PropertyTypeService {
  public async createOrUpdate(body: any) {
    const res = await http.post(
      "api/services/app/PropertyType/CreateOrUpdate",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }
  public async activate(id: number, isActive) {
    const res = await http.post(
      "api/services/app/PropertyType/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }
  public async getList(params): Promise<any> {
    const res = await http.get("api/services/app/PropertyType/GetList", {
      params,
    })
    const { result } = res.data
    return result
  }

  public async getListForAdmin(params?): Promise<any> {
    const res = await http.get(
      "api/services/app/PropertyType/GetListForAdmin",
      {
        params,
      }
    )
    const { result } = res.data
    return result
  }
  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/PropertyType/GetAll", {
      params,
    })
    return res.data.result
  }
  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/PropertyType/Get", {
      params: { id },
    })
    const { result } = res.data
    return result
  }

  public async validateBeforeImport(file: File): Promise<any> {
    const formData = new FormData()
    formData.append("file", file)
    const result = await http.post(
      "api/Imports/ProductType/ValidateBeforeImport",
      formData,
    )
    return result.data.result
  }

  public async importPropertyType(datas: Array<{ id?: number; name?: string; nameEn?: string; code?: string; rowNumber?: number }>): Promise<any> {
    const result = await http.post(
      "api/services/app/PropertyType/Import",
      datas,
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("IMPORT_SUCCESSFULLY")
    )
    return result.data.result
  }
}

export default new PropertyTypeService()
